import { createApi } from '@reduxjs/toolkit/query/react';

import {
  AttendanceRequestFormRequest,
  HrmRequestFormResponse,
} from '@Types/api/form';
import {
  RequestListSearchRequest,
  RequestListSearchResponse,
} from '@Types/api/requestList';
import { ApiBaseName, ApiReducerPath, RequestTypeCodes } from '@Enum/index';
import { PAGE_SIZE, TABLE_PAGE_DEFAULT } from '@Features/constants';
import { customBaseQuery } from '@Utils/api/customBaseQuery';

const REQ_TYPE_FILTER = {
  name: 'requestTypeID',
  value: RequestTypeCodes.ATTENDANCE_REQUEST,
  operator: 'eq',
};

export const attendanceRequestApi = createApi({
  reducerPath: ApiReducerPath.API_ATTENDANCE_REQUEST,
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getAttendanceRequests: builder.mutation<
      RequestListSearchResponse<HrmRequestFormResponse>,
      RequestListSearchRequest
    >({
      query: ({
        searchValue,
        filters = [],
        page = TABLE_PAGE_DEFAULT,
        size = PAGE_SIZE,
        sortBy = 'requestId',
        sortOrder = 'desc',
      }) => ({
        url: `${ApiBaseName.ESS}/hrm-request/search`,
        method: 'post',
        body: {
          searchValue,
          searchCriteriaList: [
            {
              searchCriterias: [...filters, REQ_TYPE_FILTER],
              dataOperator: 'and',
            },
          ],
          dataOperator: 'and',
        },
        params: { page, size, 'sort-by': sortBy, 'sort-order': sortOrder },
      }),
    }),
    postAttendanceForm: builder.mutation<
      HrmRequestFormResponse,
      AttendanceRequestFormRequest
    >({
      query: (body) => ({
        url: `${ApiBaseName.ESS}/hrm-request`,
        method: 'post',
        body: {
          ...body,
          requestTypeID: RequestTypeCodes.ATTENDANCE_REQUEST,
        },
      }),
    }),
  }),
});

export const {
  usePostAttendanceFormMutation,
  useGetAttendanceRequestsMutation,
} = attendanceRequestApi;
